import { SvgIcon, SvgIconProps } from "@mui/material";

export const EndpointRequestIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
      fill="currentColor"
    />
    <path
      d="M8 8H16V10H8V8ZM8 12H16V14H8V12ZM8 16H12V18H8V16Z"
      fill="currentColor"
      opacity="0.3"
    />
    <path
      d="M16 6H8C7.45 6 7 6.45 7 7V17C7 17.55 7.45 18 8 18H16C16.55 18 17 17.55 17 17V7C17 6.45 16.55 6 16 6ZM15 16H9V8H15V16Z"
      fill="currentColor"
    />
  </SvgIcon>
);

